import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
  apiMultipart,
  throwApiError,
} from "../utils";

export const getMatches = async (
  page,
  perPage,
  search = "",
  { sortOrder = "DESC", status } = {},
) => {
  const params = { page, perPage, search, sortOrder };
  if (status) {
    params.status = status;
  }

  const response = await apiGet("/match", params);
  const { items, totalCount, message } = await response.json();

  throwApiError(message);

  return { items, totalCount };
};

export const getMatch = async (id) => {
  const response = await apiGet(`/match/${id}`);
  const { message, ...match } = await response.json();

  throwApiError(message);

  return match;
};

export const getMatchEvents = async (matchId, { perPage, lastId, search }) => {
  const params = { perPage };
  if (lastId) {
    params.lastId = lastId;
  }
  if (search) {
    params.search = search;
  }

  const response = await apiGet(`/match/${matchId}/events`, params);
  const data = await response.json();

  throwApiError(data);

  return data;
};

export const createMatch = async (payload) => {
  const response = await apiPost("/match", payload);
  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};

export const updateMatch = async (id, payload) => {
  const response = await apiPut(`/match/${id}`, payload);
  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};

export const deleteMatch = async (id) => {
  const response = await apiDelete(`/match/${id}`);
  if (response.status === 204) {
    return {};
  }

  const { message, ...result } = await response.json();

  throwApiError(message);

  return result;
};

export const importMatchesCsv = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiMultipart("/match/import", formData, {
    method: "POST",
  });

  let data;
  try {
    data = await response.json();
  } catch {
    const text = await response.text().catch(() => "");
    throw text || "Failed to import CSV";
  }

  throwApiError(data);
  return data;
};
